import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import { HotspotItem, HotspotContent, HotspotState } from './hotspot-interfaces';
import * as Api from "@/app/interaction/api";
import { createInteractionComponent } from '@/app/interaction/ui'

@injectable()
export class IncludeHotspotHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.hotspot.component', $parsedContent);
    if (elements === null) {
      return [];
    }

    let components = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string|null = $('.hotspot__title', $element).text() || null;
    const instruction: string|null = $('.hotspot__instruction', $element).html() || null;
    const $itemsContainer: any = $('.hotspot__items', $element);
    const marker: string = $itemsContainer.attr('data-marker') || '+';
    const imageSrc: string = $itemsContainer.attr('data-image');
    const items: HotspotItem[] = this.getItems($('.hotspot__item', $itemsContainer));

    const interactionComponent = createInteractionComponent<HotspotContent, HotspotState>(id, 'hotspot', {
      title,
      instruction
    }, {
      imageSrc, marker, items
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItems($items: any): HotspotItem[] {
    let items: HotspotItem[] = [];
    $items.each((i: number, item: any) => {
      const $item = $(item);
      items = [...items, {
        x: parseInt($item.attr('data-x') as string, 10),
        y: parseInt($item.attr('data-y') as string, 10),
        content: $item.html()
      }];
    });

    return items;
  }
}
